import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";

const vuexPersist = new VuexPersist({
  key: "bayton-wl-app",
  storage: localStorage
});

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    modalCreateAccount: false,
    officeSelected: {},
    token: "",
    user: {},
    messageSelected: {},
    offerSelected: {},
    lang: "arg"
  },
  mutations: {
    setToken(state: any, token: string) {
      state.token = token;
    },
    setUser(state: any, user: any) {
      state.user = user;
    },
    logout(state: any) {
      state.token = "";
      state.user = {};
      window.location.href = "/";
    },
    setOffice(state: any, office: any) {
      state.officeSelected = office;
    },
    setMessage(state: any, message: any) {
      state.messageSelected = message;
    },
    setOffer(state: any, offer: any) {
      state.offerSelected = offer;
    },
    modalCreateAccount(state: any, status: any) {
      if (status) {
        state.modalCreateAccount = true;
      } else {
        state.modalCreateAccount = false;
      }
    },
    scrollBody(state: any, status: any) {
      if (status) {
        document.body.classList.add("no-scroll");
      } else {
        document.body.classList.remove("no-scroll");
      }
    },
    setLang(state: any, lang: any) {
      state.lang = lang;
    }
  },
  actions: {},
  plugins: [vuexPersist.plugin]
});
